import { AxiosError } from 'axios';
import toast from 'react-hot-toast';
import { parseApiError } from './errorParser';
import { ErrorType } from '../types/errors';

/**
 * Show error toast with appropriate styling based on error type
 */
export function showErrorToast(error: AxiosError): void {
  const parsed = parseApiError(error);

  switch (parsed.type) {
    case ErrorType.VALIDATION_ERROR:
      toast.error(parsed.message, {
        duration: 4000,
        icon: null,
        style: {
          background: '#FEF2F2',
          color: '#991B1B',
        },
      });
      break;

    case ErrorType.AUTH_ERROR:
      toast.error(parsed.message, {
        duration: 5000,
        icon: null,
        style: {
          background: '#FEF2F2',
          color: '#991B1B',
        },
      });
      break;

    case ErrorType.NOT_FOUND:
      toast.error(parsed.message, {
        duration: 4000,
        icon: null,
        style: {
          background: '#FFFBEB',
          color: '#92400E',
        },
      });
      break;

    case ErrorType.CONFLICT:
      toast.error(parsed.message, {
        duration: 4000,
        icon: null,
        style: {
          background: '#FEF2F2',
          color: '#991B1B',
        },
      });
      break;

    case ErrorType.SERVER_ERROR:
      toast.error(parsed.message, {
        duration: 6000,
        icon: null,
        style: {
          background: '#FEF2F2',
          color: '#991B1B',
        },
      });
      break;

    case ErrorType.NETWORK_ERROR:
      toast.error(parsed.message, {
        duration: 5000,
        icon: null,
        style: {
          background: '#EFF6FF',
          color: '#1E40AF',
        },
      });
      break;

    case ErrorType.PRECONDITION_FAILED:
      toast.error(parsed.message, {
        duration: 5000,
        icon: null,
        style: {
          background: '#FFFBEB',
          color: '#92400E',
        },
      });
      break;

    case ErrorType.PERMISSION_DENIED:
      toast.error('Acesso não autorizado', {
        duration: 5000,
        icon: null,
        style: {
          background: '#FEF2F2',
          color: '#991B1B',
        },
      });
      break;

    default:
      toast.error(parsed.message, {
        duration: 4000,
        icon: null,
      });
      break;
  }
}

/**
 * Show success toast
 */
export function showSuccessToast(message: string): void {
  toast.success(message, {
    duration: 3000,
    icon: null,
    style: {
      background: '#F0FDF4',
      color: '#166534',
    },
  });
}

/**
 * Show info toast
 */
export function showInfoToast(message: string): void {
  toast(message, {
    duration: 3000,
    icon: null,
    style: {
      background: '#EFF6FF',
      color: '#1E40AF',
    },
  });
}

/**
 * Show warning toast
 */
export function showWarningToast(message: string): void {
  toast(message, {
    duration: 4000,
    icon: null,
    style: {
      background: '#FFFBEB',
      color: '#92400E',
    },
  });
}
